<template>
    <div class="container">
        <h2 class="profile-page-title">
            {{ $t('go_conference') }}
        </h2>

        <div class="row mt-2">
            <div class="offset-0 col-12 offset-lg-3 col-lg-6 text-center" v-if="noTimetablesWarning">
                <base-alert type="warning" v-html="$t('wrong_login_notice', { email: user.email})"/>
            </div>
            <div class="col-12 text-center" v-if="error">
                <base-alert type="danger">{{error}}</base-alert>
            </div>
            <div class="col-12 text-center py-7" v-if="loading">
                <RippleLoader :color="'#5ab947'" :size="size" :duration="'1.5s'"/>
            </div>
            <div class="col-12 text-center py-7 lesson-no-nearest"
                 v-else-if="!nearestLessons || nearestLessons.length <= 0">
                {{ $t('no_lessons_today') }}
            </div>
            <div class="col-12" v-if="nearestLessons.length > 0">
                <div class="row lesson-go-item" v-for="(nearestLesson, index) in nearestLessons" :key="index">
                    <div class="col-12 text-center mt-6 lesson-go-item-title" v-if="nearestLessons.length > 1">
                        {{ nearestLesson.extendedProps.timetableName }}
                    </div>
                    <div class="col-12 text-center py-7 lesson-restricted"
                         v-if="nearestLesson.lesson && nearestLesson.lesson.restricted"
                         v-html="$t('to_go_to_lesson_prolong_subscription', { timetableName: nearestLesson.extendedProps.timetableName})">
                    </div>
                    <div class="col-12 text-center mt-4 lesson-nearest" v-else-if="nearestLesson">
                        <div class="lesson-count-down-header" v-if="timerSeconds[index] > 0"
                             v-html="$t('your_lesson_starts_after', { timetableName: nearestLesson.extendedProps.timetableName})">
                        </div>
                        <div class="lesson-count-down" v-if="timerSeconds[index] > 0">
                            {{ timerText(index) }}
                        </div>
                        <div class="lesson-count-down-notice mb-3 " v-if="timerSeconds[index] > 300">
                            {{ $t('start_conference_notice') }}
                        </div>
                        <div v-else>
                            <base-button
                                    class="mt-2 mb-2"
                                    size="lg"
                                    type="primary"
                                    @click="go()"
                            >
                                {{ $t('start_conference') }}
                                <i class="fa fa-arrow-right ml-2"></i>
                            </base-button>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-12 text-center pt-4 pb-9 lesson-nearest">

            </div>
        </div>
    </div>
</template>

<style>

    .lesson-go-item-title {
        font-family: "Manrope Bold";
        font-size: 24px;
        color: #32325d;
    }

    .lesson-no-nearest {
        font-family: "Manrope Bold";
        font-size: 24px;
        color: #8b8496;
    }

    .rasp-link {
        font-family: "Manrope Bold";
        color: white;
        text-decoration: underline;
    }

    .lesson-count-down {
        font-family: "Courier New", Courier, "Lucida Sans Typewriter", "Lucida Typewriter";
        font-size: 60px;
        color: #f15b22;
        font-weight: bold;
    }

    .lesson-count-down-notice {
        color: #8b8496;
        font-size: 14px;
    }

    .lesson-count-down-header {
        font-size: 18px;
    }

    .lesson-count-down-header > span {
        color: #231c37;
        font-size: 20px;
    }

    .lesson-restricted {
        font-family: "Manrope Bold";
        font-size: 24px;
        color: #ed1c24;
    }

</style>


<script>
    import moment from 'moment';
    import timetableApi from "../../../data/TimetablesApi";
    import {RippleLoader} from 'vue-spinners-css';
    import {getUser, isAuthenticated} from "../../../data/jwt.service";
    import ProgressApi from "@/data/ProgressApi";

    export default {
        name: "Go",
        components: {
            RippleLoader,
        },
        data() {
            return {
                duration: 4,
                size: 220,

                countDown: null,
                lessons: [],
                nextLesson: null,

                loading: true,
                error: null,

                timerSeconds: [],
                timer: null,

                noTimetablesWarning: false,
                user: null,

                nearestLessons: [],
            }
        },

        async mounted() {
            this.loading = true
            this.user = getUser()
            this.lessons = await this.getLessons()
            if (this.lessons.length > 0) {
                this.nearestLessons = this.getNearestLesson(this.lessons)
                if (!this.nearestLessons) this.nearestLessons = []
                this.loading = false
                let index = 0
                for (let nearestLesson of this.nearestLessons) {
                    let secondsToStart = nearestLesson.extendedProps.secondsToStart
                    if (secondsToStart > 60) {
                        this.startTimer(secondsToStart, index)
                    } else {
                        if (this.nearestLessons.length === 1)
                            this.go(this.nearestLessons[0])
                    }
                    index++
                }
            } else {
                this.noTimetablesWarning = true
                this.loading = false
            }
        },

        watch: {
            timerSeconds(seconds) {
                //автоматический редирект в конференцию за 1 минуту до начала
                if (this.nearestLessons.length === 1) {
                    if (seconds < 60) this.go(this.nearestLessons[0])
                }
            },
        },

        methods: {

            async go() {
                this.error = null
                this.loading = true
                //10 зерен за каждый переход на онлайн занятие
                if (isAuthenticated()) ProgressApi.addPoints(10)
                const token = await timetableApi.fetchMyTokenAsync()
                if (token) {
                  window.location.href = 'https://online.poliglotiki.com/Account/LoginByToken?token=' + token.sessionToken
                      + '&redirectUrl=https://online.poliglotiki.com/student/lessons'
                } else {
                  this.loading = false
                  this.error = 'Ошибка! Ссылка на конференцию отсутвует. Попробуйте обновить страницу [2].'
                }
            },

            startTimer(start, index) {
                this.timerSeconds[index] = start
                this.timer = setInterval(() => {
                    this.$set(this.timerSeconds, index, this.timerSeconds[index] - 1)
                }, 1000)
            },

            stopTimer() {
                clearTimeout(this.timer)
            },

            timerText(index) {
                var hours = Math.trunc(this.timerSeconds[index] / 3600)
                var mins = Math.trunc((this.timerSeconds[index] % 3600) / 60)
                var secs = this.timerSeconds[index] % 60
                if (hours > 0) return hours + "ч " + this.pad(mins, 2) + "м " + this.pad(secs, 2) + "c"
                if (mins > 0) return this.pad(mins, 2) + "м " + this.pad(secs, 2) + "c"
                return this.pad(secs, 2)
            },

            async getTimetables() {
                return await timetableApi.fetchMyTimetables()
            },

            async getLessons() {
              let today = moment().format('YYYY-MM-DD')
              let tomorrow = moment().add(1, 'days').format('YYYY-MM-DD')
              let rawLessons = await timetableApi.fetchMyTimetableByDates(today, tomorrow, false)
              rawLessons.sort((a, b) => a.dateStart.localeCompare(b.dateStart))
              return rawLessons
            },

            getNearestLesson(lessons) {
                if (!lessons || lessons.length < 1) return null
                let inProgress = []
                let upcoming = []

                for (let lesson of lessons) {
                    if (lesson.extendedProps.isInProgress) inProgress.push(lesson)
                    if (lesson.extendedProps.isUpcoming) upcoming.push(lesson)
                }

                if (inProgress.length > 0 && upcoming.length > 0) {
                    // Если у нас есть занятия в прогрессе и предстоящие занятия, то в предстоящих нужно оставить
                    // самые ближайшие, которые могут пересекаться по времени с текущими.
                    let maxSecondsToEnd = 0
                    let lessonsAll = []
                    for (let lesson of inProgress) {
                        if (lesson.extendedProps.secondsToEnd > maxSecondsToEnd)
                            maxSecondsToEnd = lesson.extendedProps.secondsToEnd
                        lessonsAll.push(lesson)
                    }
                    for (let lesson of upcoming) {
                        if (lesson.extendedProps.secondsToStart <= maxSecondsToEnd)
                            lessonsAll.push(lesson)
                    }
                    return lessonsAll
                } else {
                    if (inProgress.length > 0) return inProgress
                    if (upcoming.length > 0) return upcoming
                }

                return null
            },

            pad(num, size) {
                var s = num + "";
                while (s.length < size) s = "0" + s;
                return s;
            },
        },

        destroyed() {
            this.stopTimer()
        },
    }
</script>

